<template>
  <v-card>
    <v-card-actions>
      <v-row>
        <v-col cols="12" md="3">
          <!-- 이름 -->
          <v-text-field dense outlined hide-details :label="$t('name')" v-model="userListGrid.retrieveData.kor_nm"
                        @keyup.enter="retrieveUserListAdd"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <!-- 아이디 -->
          <v-text-field dense outlined hide-details :label="$t('id')" v-model="userListGrid.retrieveData.user_id"
                        @keyup.enter="retrieveUserListAdd"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <!-- 소속 -->
          <v-select dense outlined hide-details label="소속" :items="allCompanyList" item-value="company" item-text="asgn_shrt_nm" v-model="userListGrid.retrieveData.company">
          </v-select>
        </v-col>
        <v-col cols="12" md="3" align-self="end" class="text-right">
          <v-btn @click="retrieveUserListAdd" small outlined class="mr-1">
            <v-icon>
              mdi-magnify
            </v-icon>
            {{ $t('label.retrieve') }}
          </v-btn>
          <v-btn @click="addSelectedUser" small outlined>
            {{ $t('label.add-selected') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-text>
      <realgrid
        ref="userListGrid"
        :options="userListGrid.gridOption"
        :fields="userListGrid.gridFields"
        :columns="userListGrid.gridColumns"
        :retrieveApi="retrieveUserListGrid"
        :retrieveData="userListGrid.retrieveData"
        :height="250"
      ></realgrid>
    </v-card-text>
  </v-card>
</template>

<script>
import Message from '@/utils/message'
import Realgrid from '@/components/grid/Realgrid' // 리얼그리드 컴포넌트 사용
import {
  getCompanies,
  getUserList
} from '@/api/common/organizations' // 조직 및 인원 정보 조회

export default {
  name: 'Members',
  components: {
    Realgrid
  },
  props: {
    value: {
      company: String,
      bsns_cd: String,
      asgn_cd: String,
      user_id: String,
      kor_nm: String,
      dept_cd: String,
      default: ''
    },
    selected: Function,
    multiCheck: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      companiesList: [],
      // 사용자 찾기 Popup
      userListGrid: {
        retrieveData: {
          company: '',
          bsns_cd: '',
          user_id: '',
          kor_nm: '',
          dept_cd: '',
          custom_act: ''
        },
        // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {
              appendable: false,
              insertable: false,
              deletable: false
            },

            panel: {
              // 상단 패널 숨김
              visible: false
            },
            checkBar: {
              // 체크바 숨김
              visible: true,
              exclusive: !this.multiCheck // 단일Row만 선택 가능
            },
            stateBar: {
              // 상태바 숨김
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true
          }
        },
        gridFields: [
          { fieldName: 'gubun', dataType: 'string' },
          { fieldName: 'user_id', dataType: 'string' },
          { fieldName: 'user_nm', dataType: 'string' },
          { fieldName: 'asgn_shrt_nm', dataType: 'asgn_shrt_nm' }
        ],
        // 그리드 컬럼 배열
        gridColumns: [
          {
            name: 'gubun',
            fieldName: 'gubun',
            header: {
              text: '구분'
            },
            width: 50,
            editable: false,
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'user_id',
            fieldName: 'user_id',
            header: {
              text: '아이디'
            },
            editable: false,
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'user_nm',
            fieldName: 'user_nm',
            header: {
              text: '이름'
            },
            width: 100,
            editable: false
          },
          {
            name: 'asgn_shrt_nm',
            fieldName: 'asgn_shrt_nm',
            header: {
              text: '소속'
            },
            width: 200,
            editable: false
          }
        ]
      }
    }
  },
  mounted: function() {
    Promise.all([getCompanies()]).then(responses => {
      this.companiesList = responses[0]
    })
    this.setValue()
  },
  computed: {
    allCompanyList() {
      let allCompanyArr = [{ company: '', asgn_shrt_nm: '전체' }]
      for (let company of this.companiesList) {
        allCompanyArr.push(company)
      }
      return allCompanyArr
    },
    retrieveUserListGrid() {
      // 팝업 그리드 데이터 조회
      return getUserList
    }
  },
  methods: {
    setValue() {
      this.userListGrid.retrieveData.user_id = this.value.user_id
    },
    // 팝업 '조회' 버튼 클릭시 실행
    retrieveUserListAdd() {
      var user_nm = this.userListGrid.retrieveData.kor_nm
      if (user_nm && user_nm.length < 2) {
        Message.error('사용자 이름은 2자 이상 지정하세요')
        return
      }
      // 팝업을 열고, 그리드가 로드되는 시간동안의 시간차
      this.$nextTick(() => {
        // 프로그램 목록을 팝업 그리드에 넣는다.
        this.$refs.userListGrid.retrieve()
      })
    },
    addSelectedUser() {
      let checkItems = this.$refs.userListGrid
        .getGridView()
        .getCheckedItems(true) // 체크된 row idx 값을 가져온다.
      if (checkItems && checkItems.length > 0) {
        for (let checkItem of checkItems) {
          // console.log('checkItem :', checkItem);
          let checkRowData = this.$refs.userListGrid
            .getDataProvider()
            .getJsonRow(checkItem) // 체크된 로우의 data
          // console.log('addSelectedUser.checkRowData :', checkRowData);
          this.selected(checkRowData)
        }
      }
    }
  },
  beforeDestroy() {
    //        this.jstreeObj.jstree(true).destroy()
  }
}
</script>

<style scoped>
</style>
